import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useAgents } from "@hooks/use-agents";

export function AgentsPage() {
    const navigate = useNavigate();
    const { agents, loading } = useAgents();

    useEffect(() => {
        if (!loading && agents.length > 0) {
            navigate(`/agents/${agents[0].slug}`, { replace: true });
        }
    }, [loading, agents, navigate]);

    if (loading) {
        return (
            <div className="flex items-center justify-center h-full">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-4"></div>
                    <p>Loading agents...</p>
                </div>
            </div>
        );
    }

    return null;
}